import * as Types from '../../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GenerateMasterAccessDocumentMutationVariables = Types.Exact<{
  examId: Types.Scalars['ID'];
  validFrom: Types.Scalars['String'];
  validTo: Types.Scalars['String'];
  maxLogins: Types.Scalars['Int'];
}>;


export type GenerateMasterAccessDocumentMutation = { __typename?: 'Mutation', generateMasterAccessDocument?: { __typename?: 'GenerateMasterAccessDocumentPayload', filePath?: string | null, successful: boolean, error?: string | null, validations?: { __typename?: 'ValidationsDocumentFieldMessages', fieldMessages?: Array<{ __typename?: 'FieldMessage', field: string, messages: Array<{ __typename?: 'ValidationsMessage', message: string, severity: Types.ValidationsSeverity }> }> | null } | null } | null };

export const GenerateMasterAccessDocumentDocument = gql`
    mutation GenerateMasterAccessDocument($examId: ID!, $validFrom: String!, $validTo: String!, $maxLogins: Int!) {
  generateMasterAccessDocument(
    examId: $examId
    validFrom: $validFrom
    validTo: $validTo
    maxLogins: $maxLogins
  ) {
    filePath
    successful
    validations {
      fieldMessages {
        field
        messages {
          message
          severity
        }
      }
    }
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateMasterAccessDocumentGQL extends Apollo.Mutation<GenerateMasterAccessDocumentMutation, GenerateMasterAccessDocumentMutationVariables> {
    document = GenerateMasterAccessDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }